import { useMemo } from 'react'
import moment from 'moment'

const GHOST_MESO_VOLUME_ID = 'GHOST_MESO_VOLUME'

export default function MesoVolumeTimelineDisplay({
    renderRangeStart,
    renderRangeEnd,
    daySpacing = 0,
    programLevelHashMap = {},
    macroVolumeFocusTypeHashMap = {},
    mesoVolumes = [],
    DateToTrackLeftX = () => { return 0 }
}) {

    const mesoBars = useMemo(() => {
        if (!mesoVolumes?.length || daySpacing <= 0) return []

        const bars = []

        mesoVolumes.forEach((mesoVolumeConfig, index) => {
            const startDate = moment(mesoVolumeConfig.startDate).startOf('day')
            const endDate = moment(mesoVolumeConfig.endDate).startOf('day')

            if (
                !startDate.isValid()
                || !endDate.isValid()
                || endDate.isBefore(renderRangeStart, 'day')
                || startDate.isAfter(renderRangeEnd, 'day')
            ) {
                return
            }

            const left = DateToTrackLeftX(startDate)
            const width = DateToTrackLeftX(endDate.clone().add(1, 'day')) - left
            const isGhostWeek = mesoVolumeConfig.mesoVolumeId === GHOST_MESO_VOLUME_ID

            bars.push({
                left,
                width,
                mesoVolumeIndex: index,
                label: mesoVolumeConfig.name,
                type: mesoVolumeConfig.type,
                isGhostWeek,
                programLevelId: programLevelHashMap[mesoVolumeConfig.programLevelId],
                macroVolumeFocusTypeId: mesoVolumeConfig.macroVolumeFocusTypeId,
            })
        })

        return bars
    }, [
        renderRangeStart,
        renderRangeEnd,
        daySpacing,
        mesoVolumes,
        DateToTrackLeftX,
        programLevelHashMap,
    ])

    return (
        <div className='relative h-4 2xl:h-5'>
            {mesoBars.map((meso) => (
                <div
                    key={meso.mesoVolumeIndex}
                    className='absolute bottom-0 h-4 2xl:h-5 px-[1.5px] 2xl:px-[2px] transition-opacity'
                    style={{
                        left: `${meso.left}px`,
                        width: `${meso.width}px`,
                    }}
                >
                    <div
                        className={`
                            h-full flex items-center justify-center overflow-hidden rounded 
                            ${meso.isGhostWeek ? 'bg-gray-300' : ''}
                            ${!meso.isGhostWeek && macroVolumeFocusTypeHashMap[meso.macroVolumeFocusTypeId]?.colorHex === undefined ? 'bg-gray-200' : ''}
                        `}
                        style={
                            meso.isGhostWeek ? undefined : { backgroundColor: macroVolumeFocusTypeHashMap[meso.macroVolumeFocusTypeId]?.colorHex }
                        }
                    >
                        {!meso.isGhostWeek && (
                            <span
                                className='text-xxs 2xl:text-xs font-medium whitespace-nowrap px-1'
                                title={meso.label}
                            >
                                {/* {meso.label} */}
                                Block {meso.mesoVolumeIndex + 1}
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}
